import profileRoutes from './profileRoutes';

const providerRoutes = [...profileRoutes];

export default providerRoutes;
